import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#F4F5F8",
      direction: "rtl",
      overflow: "hidden",
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#F4F5F8",
      overflow: "hidden",
    },

    topbarWrapper: {
      width: "100%",
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 100,
      background: "#FFFFFF",
    },

    scrollContent: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: 0,
      boxSizing: "border-box",
      background: "#F4F5F8",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    pageContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
    },

  })
);

export default useStyles